import { Observable, Subscription } from 'rxjs';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import {
    SosCryptoService,
    Environment,
    AuthorizationSelectors,
    ModulesSelectors,
    CoreSelectors,
    SosLoaderService,
    NavigationSelectors,
} from '@serviceos-ng/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'serviceos-web-login-screen',
    templateUrl: './login-screen.component.html',
    styleUrls: ['./login-screen.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class LoginScreenComponent implements OnInit {

    @Select(ModulesSelectors.getImageFromModule('auth', 'auth_page_background'))
    authPageBackground$!: Observable<string>;

    @Select(ModulesSelectors.getComponentFromModule('auth', 'slider'))
    sliderData$!: Observable<any>;
    
    private subscriptions: Subscription[] = [];

    public screen = 'login';
    public isCoreInit = false;
    public isUserAuthorized = true;
    
    constructor(
        private store: Store,
        private cryptoService: SosCryptoService,
        private env: Environment,
        private router: Router,
        private route: ActivatedRoute,
        private _loaderService: SosLoaderService

    ) {}

    ngOnInit(): void {

        // Handle merge account link
        const initRoute: any = this.store.selectSnapshot(NavigationSelectors.getInitRoute);
        
        let validParams = false;
        let parsedParams = {};

        try {
            parsedParams = JSON.parse('{"' + decodeURI(initRoute.params.substring(1).replace(/&/g, "\",\"").replace(/=/g,"\":\"")) + '"}');
            validParams = true;
        } catch (error) {
            // data will remain empty if error occur when parsing
            validParams = false;
        }

        const routeParams: any = initRoute?.params && validParams ? parsedParams : '';

        if (
            initRoute?.params?.indexOf('fs_screen') > -1 &&
            routeParams?.fs_screen === 'register'
        ) {
            const path = 'create-account';
            let params = {};

            if (routeParams?.['fs_payload[merge_token]']) {
                params = { token: routeParams['fs_payload[merge_token]']}
            }
            this.router.navigate([path], { queryParams: params});
        }

        const loader = this._loaderService.showLoader();

        // this.sliderData = this.store.selectSnapshot(ModulesSelectors.getComponentFromModule(
        //     'auth',
        //     'slider'
        // ));

        this.subscriptions.push(this.store.select(CoreSelectors.completeInitialize)
            .subscribe(
                (result) => {
                    this._loaderService.hideLoader(loader);
                    this.isCoreInit = !!result;
                }
            ));

        this.subscriptions.push(this.store
            .select(AuthorizationSelectors.getAuthorization)
            .subscribe((data) => {
                if (data) {
                    
                    if (data.sid) {
                        this.router.navigate(['']);
                    } else {
                        this.isUserAuthorized = false;
                    }

                    // const sid = this.cryptoService.encryptData(data, this.env.cookieKey);
                    window.parent.postMessage(
                        { event: 'authorization', sid: data.sid },
                        '*'
                    );
                }
            }));
    }

    ngOnDestroy(): void {
        this.subscriptions.map((el) => el.unsubscribe());
    }

    public onChangeScreen(screen) {
        this.router.navigate(['/auth/' + screen], { relativeTo: this.route });
    }
}
